// ponytail: MAI-5182 reverted the user-facing name to Feed; the module dir,
// route names, event names and Announcement types keep their names. Rename
// only if the internal split ever confuses someone.
import { routes } from "./router";

import type { ModuleInitialise } from "@/types";

export const initialiseModule: ModuleInitialise = ({ router }) => {
  routes.map((route) => router.addRoute(route));
};
